import {
  Button,
  Col,
  Divider,
  Form,
  Input,
  Modal,
  Popconfirm,
  Row,
  Select,
  SelectProps,
  Spin,
  Upload,
  message,
} from "antd";

import React, { useEffect, useState } from "react";
import { MailOutlined, InboxOutlined, UndoOutlined, CopyOutlined } from "@ant-design/icons";

import { sendEmail } from "api/candidate.api";
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";

import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import { gql, useSubscription } from "@apollo/client";
import TextArea from "antd/lib/input/TextArea";

import CopyToClipboard from "react-copy-to-clipboard";
import { getRole } from "api/roles.api";
import { getEmailConfiguration } from "api/emailConfigGenerator.api";
import { notificationController } from "components/Common/Notification/Notification";
import TemplateListDropdown from "components/Common/templateListDropdown/TemplateListDropdown";
import TextGenerator from "components/Common/TextGenerator/TextGenerator";
import BulkMailForm from "components/MailComponents/BulkMail/BulkMailForm";
import { useDispatch, useSelector } from "react-redux";
import { readUser } from "services/localStorage.service";
import { notification } from "antd";
import type { RadioChangeEvent } from "antd";
import { addEventBulkMail } from "api/email.api";
import {
  addCandidates,
  replaceReduxCandidates,
  setBulkMailTalentPool,
} from "store/slices/candidateBulkMail.slice";
import BulkMailMainPage from "components/MailComponents/BulkMail/BulkMailMainPage";
import { OUTREACH_EMAIL_SUBSCRIPTION } from "gql/boolean.gql";
import { useFeatureAllowedFromState } from "services/CustomeHooks";
import { FEATURE_CONSTANTS } from "components/constants/AppConstants";

interface Props {
  emails: string[];
  className?: string;
  autoGenerate?: boolean;
  profileData?: any;
  customButton?: any;
  profileId: number;
  candidateId: number;
  onMailSent?: any;
}

const ShowModel = ({
  emails,
  onCancel,
  onSuccess,
  profileData,
  roleData,
  profileId,
  candidateId,
  onMailSent
}: any) => {
  const [searchParams] = useSearchParams();
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [bccVisible, setBccVisible] = useState(false);
  const [ccVisible, setCcVisible] = useState(false);
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Regular expression for email format
  const options: SelectProps["options"] = [];
  const [streamingText, setStreamingText] = useState("");
  const { id }: any = useParams();
  const search_id = searchParams.get("search_id");
  const [instruction, setInstruction] = useState<string[]>([]);
  const [templateData, setTemplateData] = useState<any>(null);
  const [externalCompany, setExternalCompany] = useState("");
  const talentPool = useSelector((state: any) => state.candidateBulkMail.talentPool);
  const selectedCandidates = useSelector((state: any) => state.candidateBulkMail.candidates) || [];
  const [isShowCalenderLink, setIsShowCalenderLink] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [isVideoBased, setIsVideoBased] = useState(true);
  const [subject, setSubject] = useState<any>("");
  const [selectedMails, setSelectedMails] = useState<any>([]);
  const [interviewMode, setInterviewMode] = useState<string>("screening");
  const [questionId, setQuestionId] = useState(null);
  const [message, setMessage] = useState<any>("");
  const user = readUser();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [form] = Form.useForm();
  useEffect(() => {
    if (typeof emails === "object") form.setFieldValue("recipient_emails", emails);
    else if (typeof emails === "string") form.setFieldValue("recipient_emails", [emails]);
  }, [emails]);

  const getConfig = () => {
    return getEmailConfiguration(
      profileData,
      search_id,
      roleData,
      templateData,
      externalCompany,
      profileId
    );
  };

  const { data, loading, error } = useSubscription(OUTREACH_EMAIL_SUBSCRIPTION, {
    variables: getEmailConfiguration(
      profileData,
      search_id,
      roleData,
      templateData,
      externalCompany,
      profileId
    ),
    onSubscriptionData: ({ subscriptionData }) => {
      if (subscriptionData.data.emailOutreach.text)
        form.setFieldValue("message", subscriptionData.data.emailOutreach.text);
      form.setFieldValue("subject", subscriptionData.data.emailOutreach.subject);
      setStreamingText(subscriptionData.data.emailOutreach.text);
    },
  });

  const validateEmail = (email: string) => {
    return emailPattern.test(email);
  };
  const onFinish = (event: any) => {
    const values = form.getFieldsValue();
    console.log("value", values);
    const invalidEmails = values.recipient_emails
      ? values.recipient_emails.filter((email: any) => !validateEmail(email))
      : [];
    if (invalidEmails.length > 0) {
      return Promise.reject("Please enter valid email addresses");
    }

    const bccEmails = values.bcc_emails
      ? values.bcc_emails.filter((email: any) => !validateEmail(email))
      : [];
    if (bccEmails.length > 0) {
      return Promise.reject("Please enter valid email addresses");
    }

    const ccEmails = values.cc_emails
      ? values.cc_emails.filter((email: any) => !validateEmail(email))
      : [];
    if (ccEmails.length > 0) {
      return Promise.reject("Please enter valid email addresses");
    }
    if (
      (!values.recipient_emails || !values.recipient_emails.length) &&
      (!values.bcc_emails || !values.bcc_emails.length) &&
      (!values.cc_emails || !values.cc_emails.length)
    ) {
      return;
    }
    const formData = new FormData();
    formData.append("recipient_emails", values.recipient_emails.join(";") + ";");
    if (values.cc_emails) formData.append("cc", values.cc_emails.join(";") + ";");
    if (externalCompany) formData.append("external_company", externalCompany);
    if (values.bcc_emails) formData.append("bcc", values.bcc_emails.join(";") + ";");
    formData.append("message", values.message);
    formData.append("subject", values.subject);
    if (roleData?.id) formData.append("project_id", roleData?.id);
    formData.append("candidate_id", candidateId);
    if (values.files2) {
      const originalFiles = values.files2.map((file: any) => {
        formData.append("attachments", file.originFileObj);
        return file.originFileObj;
      });
    }
    setConfirmLoading(true);
    sendEmail(formData).then(
      () => {
        form.resetFields();
        setConfirmLoading(false);
        onSuccess && onSuccess();
        notificationController.success({
          message: "Email sent successfully!",
        });
      },
      (error: any) => {
        setConfirmLoading(false);
        notificationController.error({
          message: error.message
            ? error.message
            : "Something went wrong while sending message. Please check email integration.",
        });
      }
    );
  };
  const handleVideoBasedChange = (e: RadioChangeEvent) => {
    setIsVideoBased(e.target.value);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };
  const normFile = (e: any) => {
    console.log("Upload event:", e);
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  const handleCancel = () => {
    setConfirmLoading(false);
    form.resetFields();
    onCancel && onCancel();
  };


  return (
    <Modal
      footer={null}
      title={
        <>
          <div className="flex items-center gap-2">
            <Button
              className="relative font-normal text-sm py-2 px-3 bg-transparent border-none flex gap-1 rounded-lg group text-text-tertiary shadow-none"
              onClick={() => navigate(-1)}
              icon={
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.6663 10H3.33301M3.33301 10L8.33301 15M3.33301 10L8.33301 5"
                    stroke="#667085"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              }
            />
            <div style={{ fontSize: "20px", fontWeight: "bold" }}>Send Email</div>
          </div>

          <Divider />
        </>
      }
      visible={true}
      width={"90%"}
      confirmLoading={confirmLoading}
      onCancel={onCancel}
      // style={{ top: 0, left: "50%", margin: "auto", position: "absolute" }}
      className="custom-email-modal"
    >
      <BulkMailMainPage onMailSent={onMailSent} onSuccess={onSuccess} emails={emails} />
    </Modal>
  );
};
const SendBulkEmail: React.FC<Props> = ({
  emails,
  className,
  autoGenerate,
  profileData,
  customButton,
  profileId,
  candidateId,
  onMailSent
}) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const dispatch = useAppDispatch();
  const user: any = useAppSelector((state) => state.user.user);
  const [roleData, setRoleData] = useState<any>(null);
  const userData = useAppSelector((state) => state.user);
  const isFeatureAllowed = useFeatureAllowedFromState(FEATURE_CONSTANTS.FCEI);

  const roleId = searchParams.get("roleId");
  const showModal = () => {
    setOpen(true);
  };

  const isEmailDisabled = () => !(userData.user?.email_enabled && isFeatureAllowed);

  useEffect(() => {
    if (roleId && !roleData) {
      getRoleDetails();
    }
  }, [roleId]);

  const getRoleDetails = () => {
    if (Number(roleId)) {
      getRole(Number(roleId)).then((roleDetails: any) => {
        setRoleData(roleDetails);
      });
    }
  };

  return (
    <>
      {customButton ? (
        <div className={`${isEmailDisabled() ? "cursor-not-allowed" : "cursor-pointer"}`}
          onClick={() => !isEmailDisabled() && showModal()
          }
        >{customButton}</div>
      ) : user.email_enabled === false ? (
        <Popconfirm
          title="Please enable Email integration."
          okText="Enable"
          onConfirm={() => {
            navigate("/integrations");
          }}
        ></Popconfirm>
      ) : (
        <Button
          className={className}
          type="link"
          onClick={() => !isEmailDisabled() && showModal()}
          icon={<MailOutlined />}
        // disabled={!emails || !emails.length}
        >
          Send Email
        </Button>
      )}

      {open && (
        <ShowModel
          emails={emails}
          profileData={profileData}
          profileId={profileId}
          candidateId={candidateId}
          onSuccess={() => {
            setOpen(false);
          }}
          onCancel={() => {
            setOpen(false);
          }}
          onMailSent={onMailSent}
        />
      )}
    </>
  );
};

export default SendBulkEmail;
